export default function () {
    
    createImages();

    let images = preloadImages();

    let heroAccordions = document.querySelectorAll('[data-heroaccordion]');

    for (let i = 0; i < heroAccordions.length; i++) {

        let heroAccordion = heroAccordions[i]
        let heroAccordionData = heroAccordion.getAttribute('data-heroaccordion')

        heroAccordionData = JSON.parse(heroAccordionData)

    }

    // accordian block
    let heroAccordionBlockWrappers = document.getElementsByClassName('Hero-AccordionBlock-wrapper')
    for (let i = 0; i < heroAccordionBlockWrappers.length; i++) {
        let thisId = heroAccordionBlockWrappers[i].id
        // can't throttle/debounce these functions due to the visual update not being fast enough...  
        heroAccordionBlockWrappers[i].addEventListener("mouseover", function (e) { enterHover(e, `#${thisId}`); })

        heroAccordionBlockWrappers[i].addEventListener("mouseout", function (e) { leaveHover(e, `#${thisId}`); })

    }

    //check if body has the class 'has-floating-header' and if the screen is larger than 1024px wide
    const body = document.querySelector('body');
    if (body.classList.contains('has-floating-header') && window.innerWidth > 1024) {
        const navHeight = document.querySelector('.PageNav').offsetHeight;
        const hero = document.querySelector('.Hero')
        hero.style.setProperty('padding-top', navHeight + 50 + 'px', 'important');
    }   
}

function createImages() {
    var imageDivs = $('.bgImagePlaceHolder');
    //var images = []
    for (var i = 0; i < imageDivs.length; i++) {
        if (imageDivs[i].dataset.bgImageOnHover) {
            let newImg = $(`<div class="change-bg" id="change-bg-${i + 1}" />`);
            newImg.css('background-image', `url(${imageDivs[i].dataset.bgImageOnHover})`);
            newImg.appendTo('.change-bg-wrapper');
            let altText = imageDivs[i].dataset.bgAltText;
            if (altText) {
                let screenReaderText = $(`<div class="hidden-visually"></div>`)
                screenReaderText.text(altText);
                newImg.append(screenReaderText);
            }
            
        }
        //images.push(imageDivs[i].data('bgImageOnHover'))
    }
}

function enterHover(e, element) {
    e.preventDefault()
    let $this = $(element)
    $this.find('.plus-minus-toggle').removeClass('is-collapsed')
    $this.find('.Hero-AccordionBlock-content').removeClass('is-collapsed')
    $this.find('.Hero-AccordionBlock-image--container').removeClass('is-collapsed')
    // get index of hovered item
    let idName = $this[0].id
    let testStringLength = idName.length;
    let idIndex = idName.substring(testStringLength - 1);

    // change bg image
    let backgroundChangeEl = $(`#change-bg-${idIndex}`);
    backgroundChangeEl.css('opacity', '1');

    //change hero text
    let heroChangeEl = $(`#Hero-content-text-${idIndex}`)   
    $('.Hero-content-text').removeClass('is-active')
    heroChangeEl.addClass('is-active')
}

function leaveHover(e, element) {
    e.preventDefault()
    let $this = $(element)
    $this.find('.plus-minus-toggle').addClass('is-collapsed')
    $this.find('.Hero-AccordionBlock-content').addClass('is-collapsed')
    $this.find('.Hero-AccordionBlock-image--container').addClass('is-collapsed')

    $('.change-bg').css('opacity', '0');

    $('.Hero-content-text').removeClass('is-active')
    $('#Hero-content-text-0').addClass('is-active')

}

function preloadImages() {
    $.fn.preload = function () {
        this.each(function () {
            $('<img/>')[0].src = this;
        });
    }

    var imageDivs = $('.bgImagePlaceHolder');

    var images = $([]);
    Array.from(imageDivs).forEach(imageDiv => images.push(imageDiv));
    images.preload();

    return images;
}
